import { Component } from 'react'

import { ListItem } from '@material-ui/core'
import { type ListItemProps } from '@material-ui/core/ListItem'
import { withStyles } from '@material-ui/core/styles'
import { theme } from '@procurify/ui-theme'
import { rem } from 'polished'

const styles = {
  root: {
    backgroundColor: theme.colors.white,
    paddingRight: rem(12),
    paddingTop: rem(8),
    paddingBottom: rem(8),
    paddingLeft: rem(12),
    '&:hover': {
      backgroundColor: theme.colors.selected,
    },
    // Disabled items stay focusable (aria-disabled, not MUI's disabled,
    // which removes pointer events and focus styling), so the dimming
    // MUI's disabled ListItem applies is set here.
    '&[aria-disabled="true"]': {
      opacity: 0.5,
      cursor: 'default',
      '&:hover': {
        backgroundColor: theme.colors.white,
      },
    },
  },
  selected: {
    backgroundColor: `${theme.colors.white} !important`,
  },
}

type MenuListItemStyledProps = (
  | ListItemProps<'div'>
  | ListItemProps<'a', { component: 'a' }>
) & {
  /**
   * The id of the node holding the item's description. Set here rather than
   * as `aria-describedby` on the Tooltip's child, because MUI's Tooltip reuses
   * that value as its own popup's id.
   */
  descriptionId?: string
}

class MenuListItemStyledComponent extends Component<MenuListItemStyledProps> {
  render() {
    const { classes, button, descriptionId, ...otherProps } = this.props
    return (
      <ListItem
        button={true}
        disableGutters={true}
        disableRipple={true}
        classes={{ root: classes.root, selected: classes.selected }}
        // ListItem's overloads are typed per root element; a link item
        // renders its anchor through the same props.
        {...(otherProps as Omit<ListItemProps<'div'>, 'button' | 'classes'>)}
        {...(descriptionId && { 'aria-describedby': descriptionId })}
      />
    )
  }
}

export const MenuListItemStyled = withStyles(styles)(
  MenuListItemStyledComponent
)
